import { Component } from "react";
import Swal from "sweetalert2";
import ModalAdicionarCartao from "../../../components/ModalAdicionarCartao";
import {
  getEmpresa,
  updateEmpresa,
  getCartoes,
  storeCartao,
  destroyCartao,
  updatePassword,
} from "../../../crud/configuracao.crud";
import {
  criarPayloadCartao,
  validarDadosEmpresa,
  criarPayloadEmpresa,
  validarSenha,
} from "./ConfiguracoesUtils";
import { formatCpfCnpj } from "../../../utils/Utils";
import { validarCartao } from "../../../utils/cartaoUtils";
import styles from "../../../styles/Configuracoes.module.scss";
import TabEmpresa from "./TabEmpresa";
import TabPagamento from "./TabPagamento";
import TabSenha from "./TabSenha";

const valores_iniciais_cartao = {
  nome_titular: "",
  cnpj_titular: "",
  numero_cartao: "",
  validade: "",
  cvv: "",
  pagamento_principal: false,
};

const valores_iniciais_senha = {
  current_password: "",
  new_password: "",
  confirm_password: "",
};

class ConfiguracoesPage extends Component {
  state = {
    tab_ativa: "empresa",
    loading: false,
    loading_cartoes: false,
    loading_empresa: true,

    form_empresa: { razao_social: "", cnpj: "", email: "" },
    erros_empresa: {},

    cartoes: [],
    modal_aberto: false,
    form_cartao: { ...valores_iniciais_cartao },
    erros_cartao: {},

    form_senha: { ...valores_iniciais_senha },
    erros_senha: {},
  };

  componentDidMount() {
    this.carregarEmpresa();
    this.carregarCartoes();
  }

  carregarEmpresa = () => {
    getEmpresa()
      .then((response) => {
        const empresa = response.data;

        this.setState({
          form_empresa: {
            razao_social: empresa.emp_razao_social || "",
            cnpj: formatCpfCnpj(empresa.emp_cnpj) || "",
            email: empresa.emp_email || "",
          },
        });
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ loading_empresa: false });
      });
  };

  carregarCartoes = () => {
    this.setState({ loading_cartoes: true });

    getCartoes()
      .then((response) => {
        this.setState({ cartoes: response.data });
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ loading_cartoes: false });
      });
  };

  handleChangeEmpresa = (campo, valor) => {
    this.setState((prev) => ({
      form_empresa: { ...prev.form_empresa, [campo]: valor },
      erros_empresa: { ...prev.erros_empresa, [campo]: undefined },
    }));
  };

  handleSalvarEmpresa = () => {
    const erros = validarDadosEmpresa(this.state.form_empresa);

    if (Object.keys(erros).length > 0) {
      this.setState({ erros_empresa: erros });
      Swal.fire("Ops!", Object.values(erros)[0], "warning");
      return;
    }

    this.setState({ loading: true });

    updateEmpresa(criarPayloadEmpresa(this.state.form_empresa))
      .then(() => {
        Swal.fire("Sucesso!", "Seus dados foram alterados com sucesso!", "success");
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Erro ao salvar. Tente novamente.";

        if (msg.toLowerCase().includes("cnpj")) {
          this.setState((prev) => ({
            erros_empresa: { ...prev.erros_empresa, cnpj: msg },
          }));
        }

        Swal.fire("Ops!", msg, "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  abrirModal = () => {
    this.setState({
      modal_aberto: true,
      form_cartao: { ...valores_iniciais_cartao },
      erros_cartao: {},
    });
  };

  fecharModal = () => {
    this.setState({ modal_aberto: false });
  };

  handleChangeCartao = (campo, valor) => {
    this.setState((prev) => ({
      form_cartao: { ...prev.form_cartao, [campo]: valor },
      erros_cartao: { ...prev.erros_cartao, [campo]: undefined },
    }));
  };

  handleSalvarCartao = () => {
    const erros = validarCartao(this.state.form_cartao);

    if (Object.keys(erros).length > 0) {
      this.setState({ erros_cartao: erros });
      Swal.fire("Ops!", Object.values(erros)[0], "warning");
      return;
    }

    this.setState({ loading: true });

    storeCartao(criarPayloadCartao(this.state.form_cartao))
      .then(() => {
        this.setState({ modal_aberto: false });
        this.carregarCartoes();
        Swal.fire("Sucesso!", "Cartão adicionado com sucesso!", "success");
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Erro ao salvar. Tente novamente.";
        Swal.fire("Ops!", msg, "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleExcluirCartao = (id) => {
    Swal.fire({
      title: "Atenção!",
      text: "Tem certeza que deseja remover este cartão?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then((result) => {
      if (result.isConfirmed) {
        destroyCartao(id)
          .then(() => {
            this.carregarCartoes();
          })
          .catch((err) => {
            const msg = err.response?.data?.errors?.[0] || "Erro ao excluir. Tente novamente.";
            Swal.fire("Ops!", msg, "error");
          });
      }
    });
  };

  handleChangeSenha = (campo, valor) => {
    this.setState((prev) => ({
      form_senha: { ...prev.form_senha, [campo]: valor },
      erros_senha: { ...prev.erros_senha, [campo]: undefined },
    }));
  };

  handleAlterarSenha = () => {
    const erros = validarSenha(this.state.form_senha);

    if (Object.keys(erros).length > 0) {
      this.setState({ erros_senha: erros });
      Swal.fire("Ops!", Object.values(erros)[0], "warning");
      return;
    }

    this.setState({ loading: true });

    updatePassword({
      current_password: this.state.form_senha.current_password,
      new_password: this.state.form_senha.new_password,
    })
      .then(() => {
        this.setState({
          form_senha: { ...valores_iniciais_senha },
          erros_senha: {},
        });

        Swal.fire("Sucesso!", "Senha alterada com sucesso.", "success");
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Senha atual incorreta.";
        Swal.fire("Ops!", msg, "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { tab_ativa, form_empresa, erros_empresa, loading, loading_empresa, cartoes, loading_cartoes, form_senha, erros_senha, modal_aberto, form_cartao, erros_cartao } = this.state;

    const touched_cartao = Object.keys(valores_iniciais_cartao).reduce(
      (acc, key) => ({ ...acc, [key]: true }), {}
    );

    return (
      <div className={styles.container}>
        <p className={styles.tituloPagina}>Configurações</p>

        <div className={styles.tabBar}>
          <button
            className={tab_ativa === "empresa" ? styles.tabAtiva : styles.tab}
            onClick={() => this.setState({ tab_ativa: "empresa" })}
          >
            Dados da empresa
          </button>
          <button
            className={tab_ativa === "pagamento" ? styles.tabAtiva : styles.tab}
            onClick={() => this.setState({ tab_ativa: "pagamento" })}
          >
            Métodos de pagamento
          </button>
          <button
            className={tab_ativa === "seguranca" ? styles.tabAtiva : styles.tab}
            onClick={() => this.setState({ tab_ativa: "seguranca" })}
          >
            Alterar senha
          </button>
        </div>

        <div key={tab_ativa} className={styles.tabConteudo}>
          {tab_ativa === "empresa" && (
            <TabEmpresa
              form_empresa={form_empresa}
              erros_empresa={erros_empresa}
              loading={loading}
              loading_empresa={loading_empresa}
              onChange={this.handleChangeEmpresa}
              onSalvar={this.handleSalvarEmpresa}
            />
          )}

          {tab_ativa === "pagamento" && (
            <TabPagamento
              cartoes={cartoes}
              loading_cartoes={loading_cartoes}
              onAdicionar={this.abrirModal}
              onExcluir={this.handleExcluirCartao}
            />
          )}

          {tab_ativa === "seguranca" && (
            <TabSenha
              form_senha={form_senha}
              erros_senha={erros_senha}
              loading={loading}
              onChange={this.handleChangeSenha}
              onAlterar={this.handleAlterarSenha}
            />
          )}
        </div>

        <ModalAdicionarCartao
          aberto={modal_aberto}
          onFechar={this.fecharModal}
          form_cartao={form_cartao}
          erros_cartao={erros_cartao}
          touched={touched_cartao}
          loading={loading}
          onChangeCartao={this.handleChangeCartao}
          onSalvar={this.handleSalvarCartao}
        />
      </div>
    );
  }
}

export default ConfiguracoesPage;
